import { Pipe, PipeTransform } from '@angular/core';
import { PhoneAreaCodeAR } from 'app/services/enum/phone-area-code.enum';
import { CountryPhoneCodeEnum, countryPhoneDialCodesCa } from 'app/services/enum/multiregion/country-phone-code.enum';
import { FlagPipe } from './flag.pipe';

@Pipe({
  name: 'phoneFormatter'
})
export class PhoneFormatterPipe implements PipeTransform {

  constructor(private flagPipe: FlagPipe) {}

  transform(value: string): string {
    if (value) {
      value = value.toString().replace(/\D/g, '');
      let prefix = this.findPrefix(value);
      if (prefix) {
        let telNum = prefix ? value.substring(prefix.length) : value;
        let flagPath = this.flagPipe.transform(
          CountryPhoneCodeEnum[`C${prefix}`].toUpperCase()
        );
        let plusPrefix = `+${prefix} `;

        if (countryPhoneDialCodesCa.Canada.includes(prefix)) { //Tambien Bahamas
          let auxPrefix = plusPrefix;
          plusPrefix = plusPrefix.slice(0, 2) + ' ';
          telNum = auxPrefix.slice(2).trim() + telNum;
          telNum = telNum.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
        } else if(prefix=='1'){
          let cleaned = ('' + telNum).replace(/\D/g, '');
          let match = cleaned.match(/(\d{3})(\d{3})(\d{4})$/);
          if (match) {
            telNum = [ '(', match[1], ') ', match[2], '-', match[3]].join('');
          }
        } else if(prefix=='54'){
          telNum = this.formatearTelefonoArg(telNum);
        }

        return `
        <div class="d-inline-flex align-items-center">
          <img src="/assets/images/flags/${flagPath}" alt="${plusPrefix}" title="${plusPrefix}" width="26" class="mr-1">
          <span>${plusPrefix.concat(telNum)}</span>
        </div>`;
      }
      return value;
    }
  }

  findPrefix(number: string) {
    let startWith: boolean;
    let found: any;

    for (const key in CountryPhoneCodeEnum) {
      if (CountryPhoneCodeEnum[key]) {
        const keyNum = key.substring(1);
        startWith = number.startsWith(keyNum);
        found = startWith ? keyNum : null;
        if (found) {
          break;
        }
      }
    }
    return found ? found : null;
  }

  transformWhitoutFlag(value: string): string {
    if (value) {
      value = value.toString().replace(/\D/g, '');
      const prefix = this.findPrefix(value);

      if (prefix) {
        let telNum = prefix ? value.substring(prefix.length) : value;
        const flagPath = this.flagPipe.transform(
          CountryPhoneCodeEnum[`C${prefix}`].toUpperCase()
        );
        const plusPrefix = `+${prefix} `;

        return `${plusPrefix.concat(telNum)}`;
      } else {
        return value;
      }
    }
  }

  formatearTelefonoArg(valor) {
    if (valor == null) return "";
    // 1) Normalizar a dígitos
    let n = String(valor).replace(/\D/g, "");
    // 2) Remover prefijos comunes
    if (n.startsWith("54")) n = n.slice(2);
    if (n.startsWith("0")) n = n.slice(1);
    // (Robustez) si viniera por error con '9' de móvil, lo ignoramos
    if (n.length === 11 && n.startsWith("9")) n = n.slice(1);
    // 3) Deben quedar 10 dígitos nacionales
    if (n.length !== 10) return "" + n; // no formateable perfectamente
    // 4) Listas de áreas (parcial ampliable)
    const AREA4 = new Set(PhoneAreaCodeAR[4]);
    const AREA2 = new Set(PhoneAreaCodeAR[2]); // CABA
    const AREA3 = new Set(PhoneAreaCodeAR[3]);
    let area, abonado, out;
    // 4 dígitos primero
    if (AREA4.has(n.slice(0, 4))) {
      area = n.slice(0, 4);        // xxxx
      abonado = n.slice(4);        // 6 dígitos
      out = `(${area}) ${abonado.slice(0, 2)}-${abonado.slice(2)}`; // 2-4
      return out;
    }
    // luego 3 dígitos
    if (AREA3.has(n.slice(0, 3))) {
      area = n.slice(0, 3);        // xxx
      abonado = n.slice(3);        // 7 dígitos
      out = `(${area}) ${abonado.slice(0, 3)}-${abonado.slice(3)}`; // 3-4
      return out;
    }
    // por último 2 dígitos (CABA)
    if (AREA2.has(n.slice(0, 2))) {
      area = n.slice(0, 2);        // 11
      abonado = n.slice(2);        // 8 dígitos
      out = `(${area}) ${abonado.slice(0, 4)}-${abonado.slice(4)}`; // 4-4
      return out;
    }
    // Fallback: asumir área de 4 dígitos si no matchea (mantiene 10 dígitos totales)
    area = n.slice(0, 4);
    abonado = n.slice(4);
    return `(${area}) ${abonado.slice(0, 2)}-${abonado.slice(2)}`;
  }
}
